<template>
  <div class="text-center page-form">
    <h1>Vehicle Request form here</h1>
  </div>
</template>

<script>
export default {
  head() {
    return {
      title: "Vehicle Request",
      meta: [{ name: "description", content: "ICJIA vehicle request form." }],
    };
  },
};
</script>

<style lang="scss" scoped></style>
